document.addEventListener("DOMContentLoaded", function () {
  // Trouve la section produit (id commence par MainProduct-)
  const sectionEl = document.querySelector('[id^="MainProduct-"]');
  if (!sectionEl) return;

  // Select natif de Shopify pour les variantes
  const variantSelect = sectionEl.querySelector('select[name="id"]');
  // Tous les médias de la galerie
  const mediaItems = sectionEl.querySelectorAll('.product__media-wrapper [data-media-id]');

  if (!variantSelect || mediaItems.length === 0) return;

  // Normalise (supprime accents, espaces, met en minuscule)
  const norm = (s) =>
    (s || "")
      .toString()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .toLowerCase().replace(/\s+/g, "");

  // Clé de variante basée sur le 1er attribut (souvent la couleur)
  // ex. "Rouge / 170cm" -> "rouge"
  const getVariantKey = () => {
    const opt = variantSelect.options[variantSelect.selectedIndex];
    if (!opt) return "";
    const title = opt.textContent || "";
    const firstOption = title.split(" / ")[0];
    return norm(firstOption);
  };

  // Affiche uniquement les images dont l'ALT contient la clé de variante
  const updateGallery = () => {
    const key = getVariantKey();
    mediaItems.forEach((item) => {
      const img = item.querySelector("img");
      const alt = norm(img?.alt || "");
      if (alt.includes(key)) {
        item.style.display = "";
      } else {
        item.style.display = "none";
      }
    });
  };

  // Changement via le select
  variantSelect.addEventListener("change", updateGallery);

  // Changement via les boutons (swatches)
  const infoContainer = sectionEl.querySelector('[id^="ProductInfo-"]');
  if (infoContainer) {
    infoContainer.addEventListener("change", (e) => {
      if (e.target && (e.target.name?.startsWith("options[") || e.target.name === "id")) {
        setTimeout(updateGallery, 0);
      }
    });
  }

  // Premier affichage
  updateGallery();
});
